import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { ProductWarehouseItem } from "@/graphql/codegen/graphql"
import { LabelValue } from "@/screens/Procurement/CostBreakdown/components/LabelValue"
import { SectionHeading } from "@/screens/Procurement/CostBreakdown/components/SectionHeading"
import { formatCostBreakdownCurrency } from "@/screens/Procurement/CostBreakdown/utils/formatCostBreakdownCurrency"

interface ProductCostBreakdownExpandedContentProps {
  costBreakdown: ProductWarehouseItem
}

export const ProductCostBreakdownExpandedContent: FC<ProductCostBreakdownExpandedContentProps> = ({
  costBreakdown,
}) => {
  return (
    <Box className='m-6 rounded-md bg-white'>
      <SectionHeading>Product Cost Breakdown</SectionHeading>

      <Box className='grid grid-cols-3 gap-x-8 gap-y-3'>
        <Box>
          <LabelValue label='Bare Cost per US UoM' value={formatCostBreakdownCurrency(costBreakdown.bareCost)} />
          <LabelValue
            label='Freight and Misc Cost per UoM'
            value={formatCostBreakdownCurrency(costBreakdown.freightIn)}
          />
        </Box>

        <Box />

        <Box>
          <Typography variant='body2' className='font-normal text-gray-700'>
            Total Laid-Down Cost per UoM:
          </Typography>
          <Typography className='text-lg font-bold text-gray-700'>
            {formatCostBreakdownCurrency(costBreakdown.laidDownCost)}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
